import { httpPost, httpGet } from '@/tool/request/index';
import { baseInfoConfig } from '../hooks/useBaseInfo';
const { getAppidConfig } = baseInfoConfig();
/** 登录接口返回响应 */
export interface LoginResponse extends API.RootResponse {
  data?: {
    id: number;
    token: string;
    nickName: string;
    avatarUrl: string;
  };
}

/** 微信小程序登录接口表单参数 */
export type WeappLoginData = {
  code: string;
  nickName: string;
  avatarUrl: string;
  scene?: string;
  [x: string]: any;
};

/** 獲取用戶信息接口返回响应 */
export interface userInfoObj extends API.RootResponse {
  data?: {
    submitCount: string;
    noSubmitDay: string;
    dailyAverage: string;
    monthlyAverage: string;
    username: string;
  };
}

/** 账号密码登录接口参数 */
export type PasswordLoginData = {
  loginAccount: string;
  loginPassword: string;
  verifyCode: string;
  verifyCodeKey: string;
};

/** 账号密码登录接口返回响应 */
export interface PasswordLoginResponse extends API.RootResponse {
  data?: string;
};

/** 微信小程序登录接口 */
export async function weappLogin(data: WeappLoginData) {
  return await httpPost<LoginResponse>('/wxChat/user/{appId}/login')({
    data,
    params: { code: data.code },
    urlParams: { appId: 'wxbd98988b97527df9' },
    isUrlQs: true,
  });
}

/** 退出接口 */
export async function logout() {
  return await httpGet<LoginResponse>('/api/member/logout')();
}

/** 表单参数 */
export type MemberData = {
  nickName: string;
  avatarUrl: string;
};

/** 更新会员信息 */
export async function updateMemberInfo(data: MemberData) {
  return await httpPost<API.RootResponse<any>>('/api/member/updateMemberInfo')({
    data,
  });
}

/** 获取token接口 */
export async function getToken(code: string) {
  let type = getAppidConfig?.()?.type;
  return await httpGet<API.RootResponse>('/xcx/auth/token')({
    params: { code, type },
  });
}
/** 获取用戶信息接口 */
export async function getUserInfo() {
  return await httpGet<API.RootResponse>('/xcx/user/getUserInfo')({});
}

/** 账号密码登录 */
export async function passwordLogin(data: PasswordLoginData): Promise<PasswordLoginResponse> {
  return await httpGet<PasswordLoginResponse>('/auth/login')({
    data
  });
}

// 获取验证码
export async function getPcCaptcha() {
  return await httpGet<API.RootResponse<{ verifyCodeImg: string; verifyCodeKey: string, verifyCodeText: string }>>('/auth/captcha')({});
}